import React, { Fragment } from 'react'
import AthleteCard from './athletecard'
import Ad from './sfc/ad'
import { ConvertTimestamp } from './sfc/component-helpers/convertTimestamp'
let athlete_list = require('../data/athletes.sheet.json')
if(athlete_list[0].Name.includes("full name")) {
    athlete_list.shift()
}
athlete_list = athlete_list.filter(i => i.Page_Date.length > 0)

// If "winner" property is missing, set it to false
athlete_list = athlete_list.map(d => {
    d["winner"] = (d.winner == null) ? "FALSE" : d.winner;
    return d;
});

const AthleteList = ({already_voted, closeDate, page_slug, setStoryChoice, winner_announced, theme_color}) => {
   let today = new Date().getTime()
   let closeDateParsed = new Date(closeDate).getTime()
    // console.log('converted: ', ConvertTimestamp(closeDateParsed), ' unconverted: ', closeDateParsed, ' today: ', today, ' converted < today ?', (ConvertTimestamp(closeDateParsed) < today), ' unconverted < today? ', (closeDateParsed < today))
    const closed = (ConvertTimestamp(closeDateParsed) < today)


    let filtered_list = athlete_list.filter(i => parseInt(Date.parse(new Date(i.Page_Date))) == page_slug)
    filtered_list.sort((a, b) => Number(a.winner == "FALSE") - Number(b.winner == "FALSE"))
    return(
        <div className='athlete-container'>
            {filtered_list.map((athlete, index) =>
            <AthleteCard 
                voted={already_voted} 
                setAthlete={setStoryChoice} 
                athleteName={athlete.Name} 
                athleteSport={athlete.Sport} 
                athleteSchool={athlete.School} 
                wcm={athlete.Image} 
                stats={athlete.Stats} 
                bio={athlete.Bio} 
                winner={athlete.winner} 
                voting_closed={closed} 
                theme_color={theme_color} 
                attribution={athlete.Image_Attribution}
            />)}
        </div>
    )
}
export default AthleteList
